export const TEXTS = {
  ARCHIVE_MODAL_HEADER: "Warning",
  ARCHIVE_PROVIDER_WARNING:
    "You are about to archive a provider. Do you want to continue?",
  ARCHIVE_VARIANT_WARNING:
    "You are about to archive a variant. Do you want to continue?",
  CANCEL_BUTTON_LABEL: "Cancel",
  CONFIRM_BUTTON_LABEL: "Confirm",
};

export const MENU = {
  APP: {
    DETAILS: "Provider details",
    EDIT: "Edit app provider",
    VARIANT: "Add new variant",
    DELETE: "Delete provider",
  },
  VARIANT: {
    DETAILS: "Variant details",
    EDIT: "Edit app variant",
    DELETE: "Delete variant",
  },
};
